module.exports = __webpack_public_path__ + "static/006-dcd580cfd76b7531a9d3b493c7c4c90e.png";